<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <!-- #region Datatable e Skeleton -->
    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Solicitações'"
      :newRowmodalButtonText="'Gerar Solicitação'"
      :tableHeader="headers"
      :tableRows="listaDeSolicitacoes"
      :isView="true"
      :isArquivo="true"
      v-on:datatable-newrow="novaSolicitacao"
      v-on:datatable-viewrow="visualizarSolicitacao"
      v-on:datatable-arquivo="gerarArquivo"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>
    <!-- #endregion -->

    <!-- #region ModalCustomSize -->
    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="gerarArquivo(modalCustomSize.novaSolicitacao)"
    >
      
      <!-- #region Visualizar Solicitação -->
      <div v-if="modalCustomSize.isView">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>

          <v-col cols="12">
            <v-subheader>Dados do Fiscal</v-subheader>
            <v-divider />
          </v-col>

          <v-col cols="2">
            <v-img
              :src="modalCustomSize.solicitacao.fotoUsuario"
              :lazy-src="modalCustomSize.solicitacao.fotoUsuario"
              aspect-ratio="1"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="blue lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>

          <v-col cols="10">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.nomeUsuario"
                  name="nomeUsuario"
                  label="Nome do Fiscal"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.cpfUsuario"
                  name="cpfUsuario"
                  label="CPF do Fiscal"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.emailUsuario"
                  name="emailUsuario"
                  label="Email do Fiscal"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="12">
            <v-subheader>Dados da Empresa</v-subheader>
            <v-divider />
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.nomeFantasiaEmpresa"
                  name="nomeFantasiaEmpresa"
                  label="Nome Fantasia"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.razaoSocialEmpresa"
                  name="razaoSocialEmpresa"
                  label="Razão Social"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.cevsEmpresa"
                  name="cevsEmpresa"
                  label="CEVS"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-subheader>Não Conformidades</v-subheader>
            <v-divider />
          </v-col>

          <v-col cols="12">
            <v-row v-for="(questao, i) in modalCustomSize.solicitacao.questoesSolicitadas" :key="i">
              <v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="questao.questao.nomeQuestao"
                    name="nomeQuestao"
                    autocomplete="off"
                    label="Questão"
                    rows="4"
                    row-height="30"
                    readonly
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="questao.questao.descricaoQuestao"
                    name="descricaoQuestao"
                    autocomplete="off"
                    label="Lei"
                    readonly
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-if="questao.respostaQuestao.observacao"
                    v-model="questao.respostaQuestao.observacao"
                    name="descricaoObservacao"
                    autocomplete="off"
                    label="Observação"
                    rows="3"
                    row-height="20"
                    readonly
                  />
                </v-col>

                <v-col v-if="questao.fotos && questao.fotos.length > 0" cols="12">
                  <v-row>
                    <v-col
                      v-for="(foto, l) in questao.fotos"
                      :key="l"
                      class="d-flex child-flex"
                      cols="3"
                    >
                      <img
                        v-img
                        :src="'data:image/jpeg;base64,' + foto.caminhoFoto"
                        :lazy-src="'data:image/jpeg;base64,' + foto.caminhoFoto"
                        width="100"
                        height="150"
                        style="object-fit: cover;"
                        class="white lighten-2"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>

              <v-col v-if="questao.listaAlternativa.length > 0" cols="5">
                <v-row
                  cols="12"
                  align="center"
                  v-for="(alternativa, k) in questao.listaAlternativa"
                  :key="k"
                >
                  <v-col v-if="alternativa.alternativa.tipoAlternativa == 0" cols="12">
                    <v-radio-group v-model="questao.respostaQuestao.descricaoResposta">
                      <v-radio 
                        :value="alternativa.alternativa.nomeAlternativa"
                        :label="alternativa.alternativa.nomeAlternativa"
                        :name="questao.respostaQuestao.descricaoResposta"
                        readonly
                      />
                    </v-radio-group>
                  </v-col>

                  <v-col v-if="alternativa.alternativa.tipoAlternativa == 1" cols="12">
                    <v-checkbox
                      v-model="alternativa.respostaAlternativa.descricaoResposta"
                      :label="alternativa.alternativa.nomeAlternativa"
                      :true-value="alternativa.respostaAlternativa.descricaoResposta"
                      :name="questao.questao.nomeQuestao"
                      readonly
                    />
                  </v-col>

                  <v-col v-if="alternativa.alternativa.tipoAlternativa == 2" cols="12">
                    <v-text-field
                      v-model="alternativa.respostaAlternativa.descricaoResposta"
                      autocomplete="off"
                      :label="alternativa.alternativa.nomeAlternativa"
                      :name="questao.questao.nomeQuestao"
                      readonly
                    />
                  </v-col>

                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-autocomplete
              label="Status Solicitação"
              autocomplete="off"
              :items="statusSolicitacao"
              v-model="modalCustomSize.solicitacao.statusSolicitacao"
              readonly
            />
          </v-col>

          <v-expand-transition>
            <v-col v-if="modalCustomSize.solicitacao.descricaoSolicitacao" cols="12">
              <v-textarea
                v-model="modalCustomSize.solicitacao.descricaoSolicitacao"
                name="descricaoSolicitacao"
                autocomplete="off"
                label="Descrição do Status"
                rows="3"
                row-height="20"
                readonly
              />
            </v-col>
          </v-expand-transition>
        </v-row>
      </div>
      <!-- #endregion -->
      
      <!-- #region Criar Solicitação nova -->
        <v-form v-model="estaValido">
          <div v-if="!modalCustomSize.isView && !modalCustomSize.isEdit">

            <!-- #region Selecionar o tipo de Solicitação -->
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo"
                  :items="tiposSolicitacao"
                  clearable
                  label="Selecione o tipo da Solitação"
                  :rules="[rules.requerido]"
                  autocomplete="off"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- #endregion -->

            <!-- #region Seleção de data e horas -->
            <v-expand-transition>
              <v-row v-if="modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 0 || modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 1">
                <v-col cols="12">
                  <v-subheader> Data e Horas </v-subheader>
                  <v-divider />
                </v-col>

                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted"
                        label="Data Prazo"
                        :rules="dataRules"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-mask="['##/##/####']"
                        @blur="date = parseDate(dateFormatted)"
                        v-on="on"
                        autocomplete="off"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menuTimer"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="time"
                        label="Horário da Tarefa"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menuTimer"
                      v-model="time"
                      format="24hr"
                      full-width
                      @click:minute="$refs.menu.save(time)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-expand-transition>  

            <!-- #endregion -->

            <!-- #region CASO AIP - Itens AIP -->
            <v-expand-transition>
              <v-row v-if="modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 0">
                <v-col cols="12">
                  <v-subheader> Itens AIP </v-subheader>
                  <v-divider />
                </v-col>
                <v-col v-for="(item, i) in listaDeItensAip" :key="i" cols="4" class="pa-0">
                  <v-checkbox
                    v-model="modalCustomSize.novaSolicitacao.listaDeItensAIP"
                    :label="item.nomeItem"
                    :value="item.nomeItem"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-expand-transition>
            <!-- #endregion -->

            <!-- #region CASO AIP - Numero AIF e Lavrado  -->
            <v-expand-transition>
              <v-row v-if="modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 0">
                <v-col cols="12" class="mt-4">
                  <v-subheader> Informações AIP </v-subheader>
                  <v-divider />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.solicitacao.numeroAif"
                    name="numeroAif"
                    label="Numero Auto de Infração"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.solicitacao.lavrado"
                    name="lavrado"
                    label="Lavrado"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-expand-transition>
            <!-- #endregion -->

            <!-- #region Empresa ou Nova Empresa -->
            <v-expand-transition>
              <v-row v-if="modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 0 || modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 1">
                <!-- #region Checa se é uma nova Empresa ou não -->
                <v-col cols="12">
                  <v-checkbox
                    label="Nova Empresa" 
                    v-model="novaEmpresa"
                    :value="true"
                  ></v-checkbox>
                </v-col>
                <!-- #endregion -->

                <v-col cols="12">
                  <!-- #region Seleciona empresa existente -->
                  <v-expand-transition>
                    <v-row v-if="!novaEmpresa">
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="empresaSelecionada"
                          :items="listaDeEmpresas"
                          clearable
                          label="Selecione a Empresa"
                          :rules="[rules.requerido]"
                          autocomplete="off"
                        ></v-autocomplete>
                      </v-col>

                      <v-expand-transition>
                        <v-col cols="12" v-if="modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.numeroEmpresa">
                          <v-autocomplete
                            v-model="enderecoSelecionado"
                            :items="listaEnderecos"
                            clearable
                            label="Selecione o Endereço"
                            :rules="[rules.requerido]"
                            autocomplete="off"
                          ></v-autocomplete>
                        </v-col>
                      </v-expand-transition>
                    </v-row>
                  </v-expand-transition>
                  <!-- #endregion -->

                  <!-- #region Campos de info da Empresa -->
                  <v-expand-transition>
                    <v-row v-if="mostrarInfosEmpresa">

                      <!-- #region Empresa -->
                      <v-col cols="12" class="mt-4">
                        <v-subheader>Empresa</v-subheader>
                        <v-divider />
                      </v-col>

                      <v-col cols="6">
                        <v-text-field
                          v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.nomeFantasia"
                          name="nomeFantasiaEmpresa"
                          label="Nome do Fantasia"
                          autocomplete="off"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field
                          v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.razaoSocial"
                          name="razaoSocialEmpresa"
                          label="Razão Social"
                          autocomplete="off"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field
                          v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.cnpj"
                          name="cnpjEmpresa"
                          v-mask="['##.###.###/####-##']"
                          label="CNPJ"
                          autocomplete="off"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field
                          v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.email"
                          name="emailEmpresa"
                          label="Email da Empresa"
                          autocomplete="off"
                          :rules="[rules.email]"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field
                          v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.telefone"
                          name="telefoneEmpresa"
                          v-mask="['(##)####-####', '(##)#####-####']"
                          label="Telefone da Empresa"
                          autocomplete="off"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field
                          v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.faxEmpresa"
                          name="faxEmpresa"
                          v-mask="['(##)####-####', '(##)#####-####']"
                          label="Fax da Empresa"
                          autocomplete="off"
                        ></v-text-field>
                      </v-col>

                      <!-- #endregion -->

                      <!-- #region Mostra ou não as informações de endereço -->
                      <v-expand-transition>
                        <v-col cols="12">
                          <v-row v-if="mostrarEndereco">

                            <!-- #region Endereço -->
                            <v-col cols="12" class="mt-6">
                              <v-subheader>Endereço</v-subheader>
                              <v-divider />
                            </v-col>

                            <v-col cols="12">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.endereco"
                                name="ruaEndereco"
                                label="Endereço (Rua, av., etc.)"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.numero"
                                name="numEndereco"
                                label="Numero"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.complementoEndereco"
                                name="complementoEndereco"
                                label="Complemento"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.cep"
                                name="cepEndereco"
                                label="CEP"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.cevs"
                                name="cevsEndereco"
                                label="CEVS"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>
                            <!-- #endregion -->

                            <!-- #region Responsavel -->
                            <v-col cols="12" class="mt-6">
                              <v-subheader>Responsável</v-subheader>
                              <v-divider />
                            </v-col>

                            <v-col cols="6">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.nomeNotificadoTarefa"
                                name="responsavelEmpresa"
                                label="Nome do Responsável"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.cargoNotificado"
                                name="funcaoResponsavelEmpresa"
                                label="Função do Responsável"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field
                                v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.cpfNotificadoTarefa"
                                name="cpfResponsavel"
                                label="CPF do Responsável"
                                v-mask="['###.###.###-##']"
                                autocomplete="off"
                              ></v-text-field>
                            </v-col>
                            <!-- #endregion -->
                          
                          </v-row>
                        </v-col>
                      </v-expand-transition>
                      <!-- #endregion -->

                    </v-row>
                  </v-expand-transition>
                  <!-- #endregion -->
                </v-col>
              </v-row>
            </v-expand-transition>
            <!-- #endregion -->

            <!-- #region CASO AIP - Dados Endereço responsavel -->
            <v-expand-transition>
              <v-row v-if="mostrarEndereco && modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 0">
                <v-col cols="12">
                  <v-subheader>Endereço Responsável</v-subheader>
                  <v-divider />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.enderecoResponsavel"
                    name="enderecoResponsavel"
                    label="Endereço (Rua, av., etc.)"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.numeroEnderecoResponsavel"
                    name="numeroEnderecoResponsavel"
                    label="Numero"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.complementoEnderecoResponsavel"
                    name="complementoEnderecoResponsavel"
                    label="Complemento"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.municipioEnderecoResponsavel"
                    name="municipioEnderecoResponsavel"
                    label="Município"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.telefoneResponsavel"
                    name="telefoneResponsavel"
                    v-mask="['(##)####-####', '(##)#####-####']"
                    label="Telefone do Responsável"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.emailResponsavel"
                    name="emailResponsavel"
                    label="Email do Responsável"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-expand-transition>
            <!-- #endregion -->

            <!-- #region Artigo e Descricao da solicitacao -->
            <v-expand-transition>
              <v-row v-if="modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 0 || modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo == 1">
                <v-col cols="12" class="mt-6">
                  <v-subheader>Artigo e Descrição</v-subheader>
                  <v-divider />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="modalCustomSize.novaSolicitacao.solicitacao.descricaoArtigo"
                    name="artigoSolicitacao"
                    label="Artigo"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="modalCustomSize.novaSolicitacao.solicitacao.descricaoSolicitacao"
                    name="descricaoSolicitacao"
                    label="Descrição"
                    autocomplete="off"
                    auto-grow
                    clearable
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-expand-transition>
            <!-- #endregion -->

          </div>
        </v-form>
      <!-- #endregion -->
    
    </ModalCustomSize>
    <!-- #endregion -->

    <!-- #region Relatorios -->
    <RelatorioAIF
      :isTheModalOpen="relatorioAif.estaAberto"
      :solicitacaoSelecionada="relatorioAif.solicitacaoSelecionada"
      v-on:relatorio-aif-close="fecharRelatorio"
    ></RelatorioAIF>

    <RelatorioAIP
      :isTheModalOpen="relatorioAip.estaAberto"
      :solicitacaoSelecionada="relatorioAip.solicitacaoSelecionada"
      v-on:relatorio-aif-close="fecharRelatorio"
    ></RelatorioAIP>
    <!-- #endregion -->
    
  </v-col>
</template>

<script>
//#region Importações
import store from "@/store/index";
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import ModalCustomSize from "../components/ModalCustomSize";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import RelatorioAIF from "../components/Relatorios/AIF.vue";
import RelatorioAIP from "../components/Relatorios/AIP.vue";
//#endregion

export default {
  //#region Componentes
  components: {
    DataTable,
    SkeletonTable,
    ModalCustomSize,
    Alertas,
    AlertasModal,
    RelatorioAIF,
    RelatorioAIP
  },
  //#endregion

  data: () => ({
    //#region Regras
    rules: {
      requerido: (value) => value != null || "Requer o campo!",
    },
    dataRules: [
      v => !!v || 'Data é obrigatório',
      v => (v && v.length >= 10) || 'Data contém um formato invalido',
    ],
    //#endregion

    //#region Objetos de alertas
    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },
    //#endregion

    //#region Configuração do Axios
    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },
    //#endregion

    //#region Variaveis globais
    showSkeletonTable: true,
    estaValido: false,
    empresaSelecionada: null,
    novaEmpresa: false,
    enderecoSelecionado: null,
    mostrarInfosEmpresa: false,
    mostrarEndereco: false,
    //#endregion

    //#region Variaveis de Data
    date: null,
    dateFormatted: null,
    menu: false,
    time: null,
    menuTimer: false,
    //#endregion

    //#region Objetos de relatorio
    relatorioAif: {
      estaAberto: false,
      solicitacaoSelecionada: null
    },

    relatorioAip: {
      estaAberto: false,
      solicitacaoSelecionada: null
    },
    //#endregion

    //#region Objeto da modalCustomSize
    modalCustomSize: {
      size: "1600",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isView: false,
      isExcel: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: false,
      isButtonsDisabled: false,
      //#region Objeto para visualizar a solicitação
      solicitacao: {
        numeroSolicitacao: null,
        numeroTarefaDerivada: null,
        numeroTarefaGerada: null,

        numeroUsuario: null,
        fotoUsuario: null,
        nomeUsuario: null,
        cpfUsuario: null,
        emailUsuario: null,

        numeroEmpresa: null,
        nomeFantasiaEmpresa: null,
        razaoSocialEmpresa: null,
        cevsEmpresa: null,

        questoesSolicitadas: [],

        statusSolicitacao: null,
        descricaoSolicitacao: null
      },
      //#endregion

      //#region Objeto com as variaveis para gerar uma nova Solicitação
      novaSolicitacao: {
        relatorioGerado: true,
        tipoSolicitacao: null,
        novaEmpresa: false,

        tarefaDerivada: {
          tarefa: {
            dataConclusaoTarefa: null,
            horasTarefa: null,
            nomeNotificadoTarefa: null,
            cpfNotificadoTarefa: null,
            cargoNotificado: null,

            enderecoResponsavel: null,
            numeroEnderecoResponsavel: null,
            complementoEnderecoResponsavel: null,
            municipioEnderecoResponsavel: null,
            telefoneResponsavel: null,
            emailResponsavel: null,
          },
          usuario: {
            nomeUsuario: store.getters.nome,
            numeroRegistro: store.getters.numeroRegistro
          },
          empresa: {
            numeroEmpresa: null,
            nomeFantasia: null,
            razaoSocial: null,
            cnpj: null,
            telefone: null,
            faxEmpresa: null,
            email: null,
          },
          endereco: {
            numeroEndereco: null,
            endereco: null,
            numero: null,
            complementoEndereco: null,
            cevs: null,
            cep: null
          },
        },
        solicitacao: {
          numeroSolicitacao: null,
          indicadorTipo: null,
          descricaoSolicitacao: null,
          descricaoArtigo: null,
          numeroAif: null,
          lavrado: null,
        },
        cnaeEmpresa: [],
        listaDeItensAIP: [],
      }
      //#endregion
    },
    //#endregion

    //#region Header da tabela
    headers: [
      {
        text: "ID",
        value: "solicitacao.numeroSolicitacao",
      },
      {
        text: "Empresa",
        value: "tarefaGerada.empresa.nomeFantasia",
      },
      {
        text: "Endereço",
        value: "tarefaGerada.endereco.endereco",
      },
      {
        text: "Fiscal",
        value: "tarefaGerada.usuario.nomeUsuario",
      },
      {
        text: "Roteiro Tarefa Derivada",
        value: "tarefaDerivada.roteiro.nomeRoteiro",
      },
      {
        text: "Prazo",
        value: "tarefaGerada.tarefa.dataTarefa",
      },
      {
        text: "Tipo",
        value: "solicitacao.indicadorTipo",
      },
      {
        text: "Status",
        value: "solicitacao.indicadorStatus",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],
    //#endregion

    //#region Listas globais
    listaDeSolicitacoes: [],
    listaCnaeSelecionado: [],

    statusSolicitacao: [
      {
        text: 'Aguardando Aprovação',
        value: 0
      },
      {
        text: 'Aprovado',
        value: 1
      },
      {
        text: 'Recusado',
        value: 2
      }
    ],

    tiposSolicitacao: [
      {
        text: 'AIP',
        value: 0
      },
      {
        text: 'AIF',
        value: 1
      }
    ],

    listaDeItensAip: [],
    listaDeEmpresas: [],
    listaEnderecos: [],
    //#endregion
  }),

  //#region Quando a tela iniciar é chamado a função inicializar
  created() {
    this.inicializar();
  },
  //#endregion

  watch: {
    //#region Verifica se é ou não uma nova empresa
    novaEmpresa() {
      if(this.novaEmpresa) {
        this.empresaSelecionada = null;
        this.enderecoSelecionado = null;

        this.modalCustomSize.novaSolicitacao.novaEmpresa = this.novaEmpresa;
        this.zerarCampos(true, true);
        this.mostrarInfosEmpresa = true;
        this.mostrarEndereco = true;
        
      } else {
        this.empresaSelecionada = null;
        this.enderecoSelecionado = null;
        
        this.modalCustomSize.novaSolicitacao.novaEmpresa = this.novaEmpresa;
        this.zerarCampos(true, true);
        this.mostrarInfosEmpresa = false;
        this.mostrarEndereco = false;
      }
    },
    //#endregion

    //#region Verifica se a empresa foi selecionada, caso tenha sido selecionado, filta a empresa que selecionou e popula as infos da empresa e busca todos os endereços dessa empresa
    empresaSelecionada() {
      if(this.empresaSelecionada) {
        this.listaEnderecos = [];
        const empresa = this.listaDeEmpresas.filter(empresaSelecionada => empresaSelecionada.value == this.empresaSelecionada)

        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.numeroEmpresa = this.empresaSelecionada;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.nomeFantasia = empresa[0].nomeFantasia;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.razaoSocial = empresa[0].razaoSocial;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.cnpj = empresa[0].cnpj;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.telefone = empresa[0].email;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.faxEmpresa = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.email = empresa[0].telefone;

        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.numeroEndereco = null;
        this.listarEnderecos(this.empresaSelecionada);
        this.listaTodosCnaesDaEmpresa(this.empresaSelecionada)
      } else {
        this.listaEnderecos = [];
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.numeroEmpresa = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.numeroEndereco = null;
        this.mostrarInfosEmpresa = false;
        this.zerarCampos(true, true);
      }
    },
    //#endregion

    //#region Verifica se o endereço foi selecionado, caso tenha sido selecionado filtra a lista de endereços pelo selecionado e popula as informações
    enderecoSelecionado() {
      if(this.enderecoSelecionado) {
        const endereco = this.listaEnderecos.filter(enderecoSelecionado => enderecoSelecionado.value == this.enderecoSelecionado)

        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.numeroEndereco = this.enderecoSelecionado;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.endereco = endereco[0].endereco;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.numero = endereco[0].numero;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.cep = endereco[0].cep;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.cevs = endereco[0].cevs;

        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.nomeNotificadoTarefa = endereco[0].nomeResponsavel;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.cargoNotificado = endereco[0].cargoResponsavel;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.cpfNotificadoTarefa = endereco[0].cpfResponsavel;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.telefoneResponsavel = endereco[0].telefone;

        this.mostrarInfosEmpresa = true;
        this.mostrarEndereco = true;
      } else {
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.numeroEndereco = null;
        this.mostrarEndereco = false;
        this.zerarCampos(false, true);
      }
    },
    //#endregion
    
    //#region Formatacao de Data e Horas
    date() {
      this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.dataConclusaoTarefa = this.date
      this.dateFormatted = this.formatDate(this.date);
    },

    time() {
      this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.horasTarefa = this.time
    },
    //#endregion

    //#region Verificação do v-form
    estaValido() {
      this.modalCustomSize.isButtonsDisabled = !this.estaValido;
    },
    //#endregion
  },

  methods: {
    //#region Função de inicializar, nela lista todas as solicitações do usuario
    async inicializar() {
      this.showSkeletonTable = true;
      try {
        const response = await axios.get('solicitacao', this.config);
        this.listaDeSolicitacoes = response.data;
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = 'erro';
      } finally {
        this.showSkeletonTable = false;
      }
    },
    //#endregion

    //#region Lista os endereços da empresa selecionada
    async listarEnderecos(numeroEmpresa) {
      try {
        this.alertaModal.texto = null;
        this.alertaModal.tipo = null;
        this.alertaModal.tipo = "";

        const response = await axios.put('endereco', {numeroEmpresa: numeroEmpresa}, this.config);
        this.listaEnderecos = response.data.map((enderecoSelecionado) => {
          if(enderecoSelecionado.cevs) {
            return {
              value: enderecoSelecionado.numeroEndereco,
              text: enderecoSelecionado.endereco + ` - ` + enderecoSelecionado.cevs,
              endereco: enderecoSelecionado.endereco,
              numero: enderecoSelecionado.numero,
              cep: enderecoSelecionado.cep,
              cevs: enderecoSelecionado.cevs,
              nomeResponsavel: enderecoSelecionado.nomeResponsavel,
              cargoResponsavel: enderecoSelecionado.cargoResponsavel,
              cpfResponsavel: enderecoSelecionado.cpfResponsavel,
              telefone: enderecoSelecionado.telefone
            }
          } else {
            return {
              value: enderecoSelecionado.numeroEndereco,
              text: enderecoSelecionado.endereco + ` - Não Informado`,
              endereco: enderecoSelecionado.endereco,
              numero: enderecoSelecionado.numero,
              cep: enderecoSelecionado.cep,
              cevs: enderecoSelecionado.cevs,
              nomeResponsavel: enderecoSelecionado.nomeResponsavel,
              cargoResponsavel: enderecoSelecionado.cargoResponsavel,
              cpfResponsavel: enderecoSelecionado.cpfResponsavel,
              telefone: enderecoSelecionado.telefone
            }
          }
        });
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = 'erro';
      }
    },
    //#endregion

    //#region Lista os cnaes da empresa selecionada
    async listaTodosCnaesDaEmpresa(numeroEmpresa) {
      try {
        this.alertaModal.texto = null;
        this.alertaModal.tipo = null;
        this.alertaModal.tipo = "";

        const cnaes = await axios.put('listaCnaes', {numeroEmpresa: numeroEmpresa}, this.config);
        this.modalCustomSize.novaSolicitacao.cnaeEmpresa = cnaes.data;

      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = 'erro';
      }
    },
    //#endregion

    //#region Verifica o tipo de solicitação e abre o componente de relatorio de acordo com o tipo
    async gerarArquivo(solicitacaoSelecionado) {
      if(solicitacaoSelecionado.solicitacao.indicadorTipo == 0) {
        this.relatorioAif.estaAberto = false;
        this.relatorioAip.solicitacaoSelecionada = solicitacaoSelecionado;
        this.relatorioAip.estaAberto = true;
      } else if(solicitacaoSelecionado.solicitacao.indicadorTipo == 1) {
        this.relatorioAip.estaAberto = false;
        this.relatorioAif.solicitacaoSelecionada = solicitacaoSelecionado;
        this.relatorioAif.estaAberto = true;
      }
    },
    //#endregion

    //#region Abre modal para gerar nova solicitação
    async novaSolicitacao() {
      try {
        this.alertaModal.texto = null;
        this.alertaModal.tipo = null;
        this.alertaModal.tipo = "";

        this.listaDeItensAip = [];
        this.listaDeEmpresas = [];

        //#region Lista os itens AIP
        let itensAip = await axios.get("itensAip", this.config);
        this.listaDeItensAip = itensAip.data;
        //#endregion

        //#region Lista as empresas
        let empresas = await axios.get("empresa", this.config);
        this.listaDeEmpresas = empresas.data.map((empresaSelecionada) => {
          return {
            value: empresaSelecionada.numeroEmpresa,
            text: empresaSelecionada.nomeFantasia,
            nomeFantasia: empresaSelecionada.nomeFantasia,
            razaoSocial: empresaSelecionada.razaoSocial,
            cnpj: empresaSelecionada.cnpj,
            email: empresaSelecionada.email,
            telefone: empresaSelecionada.telefone
          }
        });
        //#endregion

        this.empresaSelecionada = null;
        this.enderecoSelecionado = null;
        this.modalCustomSize.novaSolicitacao.listaDeItensAIP = [];
        this.modalCustomSize.novaSolicitacao.novaEmpresa = false;

        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.numeroEmpresa = null;
        this.zerarCampos(true, true);

        this.modalCustomSize.novaSolicitacao.solicitacao.indicadorTipo = null;
        this.modalCustomSize.novaSolicitacao.solicitacao.numeroAif = null;
        this.modalCustomSize.novaSolicitacao.solicitacao.lavrado = null;
        this.modalCustomSize.novaSolicitacao.solicitacao.descricaoArtigo = null;
        this.modalCustomSize.novaSolicitacao.solicitacao.descricaoSolicitacao = null;
        
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = 'erro';
      } finally {
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = false;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.isButtonsDisabled = !this.estaValido;
        this.modalCustomSize.buttonText = "Gerar";
        this.modalCustomSize.formTitle = "Gerar nova Solicitação";
      }
    },
    //#endregion

    //#region Abre a visualização da solicitação
    async visualizarSolicitacao(solicitacaoSelecionado) {
      try {
        this.alertaModal.texto = null;
        this.alertaModal.tipo = null;

        let tarefaCompleta = await axios.put("solicitacaoCompleta", solicitacaoSelecionado.solicitacao, this.config);
        this.modalCustomSize.solicitacao.questoesSolicitadas = tarefaCompleta.data;
        this.alertaModal.tipo = "";

        this.modalCustomSize.solicitacao.numeroSolicitacao = solicitacaoSelecionado.solicitacao.numeroSolicitacao;
        this.modalCustomSize.solicitacao.numeroTarefaDerivada = solicitacaoSelecionado.solicitacao.numeroTarefaDerivada;
        this.modalCustomSize.solicitacao.numeroTarefaGerada = solicitacaoSelecionado.solicitacao.numeroTarefaGerada;
        this.modalCustomSize.solicitacao.statusSolicitacao = solicitacaoSelecionado.solicitacao.indicadorStatus;
        this.modalCustomSize.solicitacao.descricaoSolicitacao = solicitacaoSelecionado.solicitacao.descricaoStatus;

        this.modalCustomSize.solicitacao.numeroUsuario = solicitacaoSelecionado.tarefaGerada.usuario.numeroUsuario;
        this.modalCustomSize.solicitacao.fotoUsuario = solicitacaoSelecionado.tarefaGerada.usuario.foto;
        this.modalCustomSize.solicitacao.nomeUsuario = solicitacaoSelecionado.tarefaGerada.usuario.nomeUsuario;
        this.modalCustomSize.solicitacao.cpfUsuario = solicitacaoSelecionado.tarefaGerada.usuario.cpf;
        this.modalCustomSize.solicitacao.emailUsuario = solicitacaoSelecionado.tarefaGerada.usuario.email;

        this.modalCustomSize.solicitacao.numeroEmpresa = solicitacaoSelecionado.tarefaGerada.empresa.numeroEmpresa;
        this.modalCustomSize.solicitacao.nomeFantasiaEmpresa = solicitacaoSelecionado.tarefaGerada.empresa.nomeFantasia;
        this.modalCustomSize.solicitacao.razaoSocialEmpresa = solicitacaoSelecionado.tarefaGerada.empresa.razaoSocial;
        this.modalCustomSize.solicitacao.cevsEmpresa = solicitacaoSelecionado.tarefaGerada.endereco.cevs;
        
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = 'erro';
      } finally {
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = true;
        this.modalCustomSize.isButtonsVisible = false;
        this.estaValido = true;
        this.modalCustomSize.isButtonsDisabled = false;
        this.modalCustomSize.formTitle = "Visualizar Solicitação";
      }
    },
    //#endregion

    //#region Função criada para zerar os campos necessarios
    zerarCampos(zerarEmpresa, zerarEndereco) {
      if(zerarEmpresa) {
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.nomeFantasia = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.razaoSocial = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.cnpj = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.telefone = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.faxEmpresa = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.empresa.email = null;
      }

      if(zerarEndereco) {
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.endereco = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.numero = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.complementoEndereco = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.cep = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.endereco.cevs = null;
  
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.nomeNotificadoTarefa = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.cargoNotificado = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.cpfNotificadoTarefa = null;

        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.enderecoResponsavel = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.numeroEnderecoResponsavel = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.complementoEnderecoResponsavel = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.municipioEnderecoResponsavel = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.telefoneResponsavel = null;
        this.modalCustomSize.novaSolicitacao.tarefaDerivada.tarefa.emailResponsavel = null;
      }
    },
    //#endregion

    //#region Função com o proposito de fechar os componentes de Relatorio
    fecharRelatorio() {
      this.relatorioAip.solicitacaoSelecionada = null;
      this.relatorioAip.estaAberto = false;

      this.relatorioAif.solicitacaoSelecionada = null;
      this.relatorioAif.estaAberto = false;
    },
    //#endregion
  
    //#region Formatações de Datas
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    //#endregion
  },
};
</script>
